import { useQuery as b } from "./contact-channels42.js";
import { useContactChannelsContext as f } from "./contact-channels19.js";
import { useTranslations as C } from "./contact-channels43.js";
import { useChannelsData as y } from "./contact-channels44.js";
import { useEmergencyCheck as A } from "./contact-channels2.js";
import { NRLogger as m } from "./contact-channels45.js";
const I = (i = !0) => {
  const { proadvantageType: s, isProadvantage: t } = f(), { t: e } = C(), { data: a, isLoading: d } = A(i), { data: n, isLoading: c } = y(i);
  return b({
    queryKey: ["email"],
    queryFn: async () => {
      if (a != null && a.enabled && (a != null && a.config.emailDisabled))
        return m.warn("Contact Channels: useEmail", {
          emergencyEnabled: a.enabled,
          emailDisabled: a.config.emailDisabled,
          message: "Email service is disabled due to emergency",
          reason: "EMERGENCY"
        }), {
          isAvailable: !1,
          availabilityInfo: {
            emergencyMessage: a.message,
            reason: "EMERGENCY"
          },
          ui: {
            title: e("phone.title"),
            description: e("phone.service_unavailable")
          }
        };
      const { email: p } = (n == null ? void 0 : n.contactChannels) || {}, { scheduleMsg: u, proadvantageEmailAddress: g, premiumProadvantageEmailAddress: v } = p || {};
      let l = e("email.proadvantage.call_us");
      const o = s === "basic" ? g : v, E = `<a href='mailto:${o}'>${o}</a>`;
      l = l.split("{1}").join(E);
      const h = e("email.proadvantage.support_care_team"), r = t ? l : u;
      return r ? {
        isAvailable: !0,
        plainData: {
          scheduleMessage: r,
          proAdvantageSupportPhrase: h,
          emailAddress: o,
          isProadvantage: t,
          proadvantageType: s
        },
        ui: {
          title: e("email.title"),
          description: r
        }
      } : (m.warn("Contact Channels: useEmail", {
        message: "Email service is disabled due to missing schedule message",
        reason: "DISABLED",
        hasScheduleMessage: !1,
        isProadvantage: t || !1,
        proadvantageType: s || "none"
      }), {
        isAvailable: !1,
        availabilityInfo: {
          reason: "DISABLED"
        },
        ui: {
          title: e("email.title"),
          description: e("email.service_unavailable")
        }
      });
    },
    staleTime: 5 * 60 * 1e3,
    gcTime: 5 * 60 * 1e3,
    enabled: !d && !c && i
  });
};
export {
  I as useEmail
};
//# sourceMappingURL=contact-channels6.js.map
